<template>
  <div class="page-wrapper">
    <Header :active-nav="activeNav" @nav-click="scrollToSection" />
    <Carousel />
    <div class="page-content">
      <section class="page-title-section">
        <div class="page-title-container">
          <div class="page-title-icon">
            <i class="fas fa-industry"></i>
          </div>
          <h1 class="page-title">舟山工厂</h1>
          <p class="page-subtitle">ZhouShan Factory</p>
          <div class="page-title-line"></div>
        </div>
      </section>

      <main class="company-detail">
        <section class="company-overview">
          <div class="overview-card">
            <div class="overview-header">
              <h2>浙江太丰食品科技有限公司</h2>
              <div class="overview-tagline">
                <span class="badge">浙江老字号</span>
                <span class="badge">综合性食品生产基地</span>
                <span class="badge">全产业链布局</span>
              </div>
            </div>

            <div class="overview-content">
              <div class="mission-statement">
                <div class="mission-icon">
                  <i class="fas fa-bullseye"></i>
                </div>
                <div class="mission-text">
                  <h3>企业使命</h3>
                  <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    立足舟山粮食产业园，太丰食品科技将充分发挥"老字号"品牌与全产业链的双重优势，以创新为驱动，以品质为基石，致力于成为长三角地区领先的休闲食品制造与服务商，构建一个贯通国内外、连接B端与C端的现代化食品产业平台，不仅在传统肉制品领域不断深耕，更在全球坚果供应链中扮演关键角色，为中国消费市场的高质量发展注入持久动力。
                  </p>
                </div>
              </div>

              <div class="investment-info">
                <div class="info-grid">
                  <div class="info-item">
                    <div class="info-icon">
                      <i class="fas fa-money-bill-wave"></i>
                    </div>
                    <div class="info-content">
                      <div class="info-value">3亿元</div>
                      <div class="info-label">项目总投资</div>
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="info-icon">
                      <i class="fas fa-map-marker-alt"></i>
                    </div>
                    <div class="info-content">
                      <div class="info-value">60亩</div>
                      <div class="info-label">用地面积</div>
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="info-icon">
                      <i class="fas fa-chart-line"></i>
                    </div>
                    <div class="info-content">
                      <div class="info-value">5亿元</div>
                      <div class="info-label">预计年产值</div>
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="info-icon">
                      <i class="fas fa-calendar-check"></i>
                    </div>
                    <div class="info-content">
                      <div class="info-value">2026年</div>
                      <div class="info-label">投入运营</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="business-sectors">
          <div class="section-header">
            <h3>核心业务板块</h3>
          </div>

          <div class="sectors-container">
            <div class="sector-card sector-meat">
              <div class="sector-header">
                <div class="sector-icon">
                  <i class="fas fa-drumstick-bite"></i>
                </div>
                <h4>肉制品加工与销售</h4>
                <div class="sector-badge">核心业务</div>
              </div>

              <div class="sector-content">
                <div class="sector-highlight">
                  <i class="fas fa-award"></i>
                  <span>守护"浙江老字号"金字招牌</span>
                </div>

                <div class="sector-features">
                  <div class="feature-item">
                    <div class="feature-icon">
                      <i class="fas fa-flask"></i>
                    </div>
                    <div class="feature-text">
                      <strong>加大研发投入</strong>
                      <p>构建从生产到销售的全链条管控体系</p>
                    </div>
                  </div>

                  <div class="feature-item">
                    <div class="feature-icon">
                      <i class="fas fa-shield-alt"></i>
                    </div>
                    <div class="feature-text">
                      <strong>品质安全保障</strong>
                      <p>确保产品在品质、口感与食品安全方面保持高度稳定性</p>
                    </div>
                  </div>

                  <div class="feature-item">
                    <div class="feature-icon">
                      <i class="fas fa-search"></i>
                    </div>
                    <div class="feature-text">
                      <strong>全程可追溯</strong>
                      <p>实现"源头可溯、品质可控"的质量管理体系</p>
                    </div>
                  </div>
                </div>

                <div class="oem-service">
                  <h5>OEM/ODM服务</h5>
                  <div class="client-list">
                    <span class="client-tag">三只松鼠</span>
                    <span class="client-tag">良品铺子</span>
                    <span class="client-tag">更多品牌...</span>
                  </div>
                  <p class="service-desc">
                    提供涵盖产品研发、配方定制与规模化生产的一体化解决方案
                  </p>
                </div>
              </div>
            </div>

            <div class="sector-card sector-nuts">
              <div class="sector-header">
                <div class="sector-icon">
                  <i class="fas fa-seedling"></i>
                </div>
                <h4>坚果生产与贸易</h4>
                <div class="sector-badge">战略布局</div>
              </div>

              <div class="sector-content">
                <div class="industry-insight">
                  <div class="insight-stat">
                    <div class="stat-number">90%</div>
                    <div class="stat-label">国内腰果依赖进口</div>
                  </div>
                  <p class="insight-text">
                    基于国内腰果约90%依赖越南进口的产业现状
                  </p>
                </div>

                <div class="supply-chain">
                  <h5>全球供应链布局</h5>
                  <div class="chain-steps">
                    <div class="chain-step">
                      <div class="step-icon">
                        <i class="fas fa-globe-africa"></i>
                      </div>
                      <div class="step-content">
                        <strong>非洲直采</strong>
                        <p>在非洲建立优质原料直采渠道</p>
                      </div>
                    </div>

                    <div class="chain-step">
                      <div class="step-icon">
                        <i class="fas fa-ship"></i>
                      </div>
                      <div class="step-content">
                        <strong>舟山加工</strong>
                        <p>在舟山设立现代化加工生产基地</p>
                      </div>
                    </div>

                    <div class="chain-step">
                      <div class="step-icon">
                        <i class="fas fa-chart-network"></i>
                      </div>
                      <div class="step-content">
                        <strong>垂直整合</strong>
                        <p>"从源头到成品"的完整产业链</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="value-proposition">
                  <div class="value-item">
                    <i class="fas fa-handshake"></i>
                    <span>为行业客户提供高性价比原料</span>
                  </div>
                  <div class="value-item">
                    <i class="fas fa-heart"></i>
                    <span>保障终端消费者的产品新鲜度与卓越品质</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="company-advantages">
          <div class="section-header">
            <h3>企业核心优势</h3>
          </div>

          <div class="advantages-grid">
            <div class="advantage-card">
              <div class="advantage-image logo-image">
                <img src="@/assets/logo/logo_fixed.png" alt="老字号传承" />
              </div>
              <h4>老字号传承</h4>
              <p>拥有"浙江老字号"品牌优势，百年工艺传承与现代化生产相结合</p>
            </div>

            <div class="advantage-card">
              <div class="advantage-image">
                <img src="@/assets/factory/page/2.png" alt="全产业链布局" />
              </div>
              <h4>全产业链布局</h4>
              <p>从原料采购到成品销售的完整产业链控制能力</p>
            </div>

            <div class="advantage-card">
              <div class="advantage-image">
                <img src="@/assets/factory/page/1.png" alt="全球化视野" />
              </div>
              <h4>全球化视野</h4>
              <p>建立全球原料供应网络，布局国际坚果贸易</p>
            </div>

            <div class="advantage-card">
              <div class="advantage-image">
                <img src="@/assets/factory/page/3.png" alt="现代化基地" />
              </div>
              <h4>现代化基地</h4>
              <p>总投资3亿元，建设智能化、标准化的食品生产基地</p>
            </div>
          </div>
        </section>

        <section class="honor-certificates">
          <div class="section-header">
            <h3>荣誉资质</h3>
          </div>

          <div class="honor-container">
            <div class="honor-grid">
              <div class="honor-item">
                <div class="honor-image">
                  <img src="@/assets/factory/honor/1.png" alt="荣誉资质证书一" loading="lazy" />
                </div>
              </div>
              <div class="honor-item">
                <div class="honor-image">
                  <img src="@/assets/factory/honor/2.png" alt="荣誉资质证书二" loading="lazy" />
                </div>
              </div>
              <div class="honor-item">
                <div class="honor-image">
                  <img src="@/assets/factory/honor/3.png" alt="荣誉资质证书三" loading="lazy" />
                </div>
              </div>
              <div class="honor-item">
                <div class="honor-image">
                  <img src="@/assets/factory/honor/4.png" alt="荣誉资质证书四" loading="lazy" />
                </div>
              </div>
              <div class="honor-item">
                <div class="honor-image">
                  <img src="@/assets/factory/honor/5.png" alt="荣誉资质证书五" loading="lazy" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>

    <Footer @scroll-to="scrollToSection" @show-product="showProduct" />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Carousel from "@/components/contentPage/Factory_Carousel.vue";

export default {
  name: "Company",
  components: {
    Header,
    Footer,
    Carousel,
  },
  data() {
    return {
      activeNav: "company",
    };
  },
  mounted() {
    this.initScroll();
  },
  methods: {
    initScroll() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    scrollToSection(sectionId) {
      this.$router.push({ name: "Home", hash: `#${sectionId}` });
    },
    showProduct(id) {
      this.$router.push({ name: "ProductDetail", params: { id } });
    },
  },
};
</script>

<style scoped>
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.page-content {
  flex: 1;
}

.page-title-section {
  background: linear-gradient(
      135deg,
      rgba(158, 19, 23, 0.08),
      rgba(158, 19, 23, 0.02)
  );
  padding: 100px 20px 50px;
  text-align: center;
  position: relative;
}

.page-title-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(to right, #9e1317, #b81c22);
}

.page-title-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #9e1317, #b81c22);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  font-size: 2.5rem;
  color: white;
  box-shadow: 0 10px 25px rgba(158, 19, 23, 0.2);
}

.page-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: #222222;
  margin-bottom: 10px;
}

.page-subtitle {
  font-size: 1rem;
  color: #666666;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 20px;
}

.page-title-line {
  width: 80px;
  height: 3px;
  background: linear-gradient(to right, #9e1317, #b81c22);
  margin: 0 auto;
  border-radius: 2px;
}

.company-detail {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  background: #ffffff;
}

.company-overview {
  margin-bottom: 50px;
}

.overview-card {
  background: rgba(158, 19, 23, 0.03);
  border-radius: 20px;
  padding: 40px;
  border: 1px solid rgba(158, 19, 23, 0.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.overview-header h2 {
  font-size: 2rem;
  color: #222222;
  text-align: center;
  margin-bottom: 20px;
}

.overview-tagline {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 30px;
}

.badge {
  background: rgba(158, 19, 23, 0.08);
  color: #9e1317;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  border: 1px solid rgba(158, 19, 23, 0.2);
}

.mission-statement {
  display: flex;
  align-items: center;
  gap: 20px;
  background: rgba(158, 19, 23, 0.06);
  border-radius: 15px;
  padding: 25px;
  margin-bottom: 30px;
  border: 1px solid rgba(158, 19, 23, 0.15);
}

.mission-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #9e1317, #b81c22);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
  flex-shrink: 0;
}

.mission-text h3 {
  font-size: 1.3rem;
  color: #222222;
  margin-bottom: 10px;
}

.mission-text p {
  font-size: 1rem;
  line-height: 1.6;
  color: #444444;
}

.investment-info {
  margin-top: 30px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.info-item {
  background: rgba(158, 19, 23, 0.03);
  border-radius: 15px;
  padding: 20px;
  text-align: center;
  border: 1px solid rgba(158, 19, 23, 0.1);
  transition: all 0.3s;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.03);
}

.info-item:hover {
  background: rgba(158, 19, 23, 0.06);
  border-color: rgba(158, 19, 23, 0.2);
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(158, 19, 23, 0.1);
}

.info-icon {
  width: 50px;
  height: 50px;
  background: rgba(158, 19, 23, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: #9e1317;
  margin: 0 auto 15px;
}

.info-value {
  font-size: 1.8rem;
  font-weight: 700;
  color: #9e1317;
  margin-bottom: 5px;
}

.info-label {
  font-size: 0.9rem;
  color: #666666;
}

.business-sectors {
  margin-bottom: 50px;
}

.section-header {
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 2px solid rgba(158, 19, 23, 0.15);
  position: relative;
}

.section-header h3 {
  font-size: 1.8rem;
  color: #222222;
  position: relative;
  display: inline-block;
  padding-right: 15px;
}

.section-header h3::after {
  content: "";
  position: absolute;
  bottom: -17px;
  left: 0;
  width: 80px;
  height: 4px;
  background: linear-gradient(to right, #9e1317, #b81c22);
  border-radius: 2px;
}

.sectors-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.sector-card {
  background: rgba(158, 19, 23, 0.02);
  border-radius: 20px;
  padding: 30px;
  border: 1px solid rgba(158, 19, 23, 0.1);
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.sector-card:hover {
  background: rgba(158, 19, 23, 0.04);
  border-color: rgba(158, 19, 23, 0.2);
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(158, 19, 23, 0.1);
}

.sector-meat {
  border-top: 4px solid #9e1317;
}

.sector-nuts {
  border-top: 4px solid rgba(158, 19, 23, 0.6);
}

.sector-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 25px;
  position: relative;
}

.sector-icon {
  width: 60px;
  height: 60px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
  flex-shrink: 0;
}

.sector-meat .sector-icon {
  background: linear-gradient(135deg, #9e1317, #b81c22);
}

.sector-nuts .sector-icon {
  background: linear-gradient(
      135deg,
      rgba(158, 19, 23, 0.8),
      rgba(184, 28, 34, 0.6)
  );
}

.sector-header h4 {
  font-size: 1.4rem;
  color: #222222;
  margin: 0;
}

.sector-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(158, 19, 23, 0.1);
  color: #9e1317;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
}

.sector-highlight {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(158, 19, 23, 0.06);
  padding: 12px 15px;
  border-radius: 10px;
  margin-bottom: 20px;
}

.sector-highlight i {
  color: #9e1317;
}

.sector-highlight span {
  color: #222222;
  font-weight: 500;
}

.sector-features {
  margin-bottom: 25px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  margin-bottom: 15px;
  padding: 10px;
  border-radius: 10px;
  transition: all 0.3s;
}

.feature-item:hover {
  background: rgba(158, 19, 23, 0.03);
}

.feature-icon {
  width: 40px;
  height: 40px;
  background: rgba(158, 19, 23, 0.08);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  color: #9e1317;
  flex-shrink: 0;
}

.feature-text strong {
  display: block;
  color: #222222;
  margin-bottom: 5px;
  font-size: 1rem;
}

.feature-text p {
  font-size: 0.9rem;
  color: #444444;
  line-height: 1.5;
}

.oem-service {
  background: rgba(158, 19, 23, 0.03);
  border-radius: 15px;
  padding: 20px;
  margin-top: 20px;
  border: 1px solid rgba(158, 19, 23, 0.1);
}

.oem-service h5 {
  color: #222222;
  margin-bottom: 10px;
  font-size: 1.1rem;
}

.client-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.client-tag {
  background: rgba(158, 19, 23, 0.08);
  color: #9e1317;
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 0.85rem;
  border: 1px solid rgba(158, 19, 23, 0.2);
}

.service-desc {
  font-size: 0.9rem;
  color: #444444;
  line-height: 1.5;
}

.industry-insight {
  background: rgba(158, 19, 23, 0.04);
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid rgba(158, 19, 23, 0.15);
}

.insight-stat {
  text-align: center;
  margin-bottom: 10px;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 800;
  color: #9e1317;
}

.stat-label {
  font-size: 0.9rem;
  color: #666666;
}

.insight-text {
  text-align: center;
  color: #444444;
  font-size: 0.95rem;
}

.supply-chain h5 {
  color: #222222;
  margin-bottom: 15px;
  font-size: 1.1rem;
}

.chain-steps {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
}

.chain-step {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 12px;
  background: rgba(158, 19, 23, 0.02);
  border-radius: 10px;
  transition: all 0.3s;
}

.chain-step:hover {
  background: rgba(158, 19, 23, 0.04);
}

.step-icon {
  width: 45px;
  height: 45px;
  background: rgba(158, 19, 23, 0.08);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: #9e1317;
  flex-shrink: 0;
}

.step-content strong {
  display: block;
  color: #222222;
  margin-bottom: 5px;
  font-size: 1rem;
}

.step-content p {
  font-size: 0.9rem;
  color: #444444;
}

.value-proposition {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.value-item {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #444444;
  font-size: 0.95rem;
}

.value-item i {
  color: #9e1317;
}

.company-advantages {
  margin-bottom: 50px;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.advantage-card {
  background: rgba(158, 19, 23, 0.02);
  border-radius: 15px;
  padding: 25px 20px;
  text-align: center;
  border: 1px solid rgba(158, 19, 23, 0.1);
  transition: all 0.3s;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.03);
}

.advantage-card:hover {
  background: rgba(158, 19, 23, 0.04);
  border-color: rgba(158, 19, 23, 0.2);
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(158, 19, 23, 0.1);
}

.advantage-image {
  width: 100%;
  height: 120px;
  border-radius: 12px;
  margin: 0 auto 15px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(158, 19, 23, 0.05);
}

.advantage-card:nth-child(1) .advantage-image {
  height: 120px;
  background: transparent;
}

.logo-image {
  display: flex;
  align-items: center;
  justify-content: center;
}

.advantage-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.advantage-card:nth-child(1) .advantage-image img {
  width: 100px;
  height: auto;
  max-width: 150px;
  max-height: 100px;
  object-fit: contain;
}

.advantage-card:hover .advantage-image img {
  transform: scale(1.05);
}

.advantage-card h4 {
  font-size: 1.1rem;
  color: #222222;
  margin-bottom: 10px;
}

.advantage-card p {
  font-size: 0.9rem;
  color: #444444;
  line-height: 1.5;
}

.honor-certificates {
  margin-bottom: 50px;
}

.honor-container {
  background: rgba(158, 19, 23, 0.02);
  border-radius: 20px;
  padding: 40px;
  border: 1px solid rgba(158, 19, 23, 0.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}

.honor-container:hover {
  background: rgba(158, 19, 23, 0.03);
  border-color: rgba(158, 19, 23, 0.15);
  box-shadow: 0 6px 20px rgba(158, 19, 23, 0.08);
}

.honor-grid {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.honor-item {
  background: white;
  border-radius: 15px;
  overflow: hidden;
  border: 1px solid rgba(158, 19, 23, 0.1);
  transition: all 0.3s;
  position: relative;
}

.honor-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(to right, #9e1317, #b81c22);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 1;
}

.honor-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(158, 19, 23, 0.12);
  border-color: rgba(158, 19, 23, 0.2);
}

.honor-item:hover::before {
  opacity: 1;
}

.honor-image {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(158, 19, 23, 0.02);
}

.honor-image img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.5s ease;
}

.honor-item:hover .honor-image img {
  transform: scale(1.02);
}

@media (max-width: 992px) {
  .sectors-container,
  .advantages-grid {
    grid-template-columns: 1fr;
  }

  .info-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .honor-container {
    padding: 30px;
  }
}

@media (max-width: 768px) {
  .overview-card,
  .honor-container {
    padding: 30px 20px;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .mission-statement {
    flex-direction: column;
    text-align: center;
  }

  .advantage-image {
    height: 100px;
  }

  .advantage-card:nth-child(1) .advantage-image {
    height: 100px;
  }

  .advantage-card:nth-child(1) .advantage-image img {
    max-width: 100px;
    max-height: 70px;
  }

  .honor-grid {
    gap: 20px;
  }
}

@media (max-width: 576px) {
  .page-title {
    font-size: 2rem;
  }

  .company-detail {
    padding: 30px 15px;
  }

  .overview-header h2 {
    font-size: 1.6rem;
  }

  .section-header h3 {
    font-size: 1.5rem;
  }

  .sector-header {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }

  .sector-badge {
    position: relative;
    display: inline-block;
    margin-top: 10px;
  }

  .chain-step {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }

  .advantage-image {
    height: 80px;
  }

  .advantage-card:nth-child(1) .advantage-image {
    height: 80px;
  }

  .advantage-card:nth-child(1) .advantage-image img {
    max-width: 80px;
    max-height: 60px;
  }

  .honor-container {
    padding: 25px 15px;
  }

  .honor-grid {
    gap: 15px;
  }

  .honor-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(158, 19, 23, 0.1);
  }
}
</style>